import React, { Component } from 'react';
import { Tree } from 'antd';
import {queryOrgTree} from "@api/core/org";

const { TreeNode } = Tree;

class SelectOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      checkedKeys: [],
    };
  }

  componentDidMount() {
    this.loadData();
    this.setState({ checkedKeys: this.props.checkedKeys });
  }

  componentWillReceiveProps(nextProps) {
    this.props.checkedKeys !== nextProps.checked &&
      this.setState({ checkedKeys: nextProps.checkedKeys });
  }

  loadData = () => {
    return queryOrgTree().then(res => {
      if (res.statusCode === 200) {
        this.setState({ list: res.data });
      }
    });
  };

  onCheck = (value, e) => {
    const { setStateCheckedKeys, setStateSelectedItems } = this.props;
    let { selectedItems } = this.props;
    if (e.checked) {
      selectedItems.push({
        uuid: e.node.props.dataRef.uuid || '',
        name: e.node.props.dataRef.name || '',
      });
    } else {
      selectedItems = selectedItems.filter(item => item.uuid !== e.node.props.dataRef.uuid);
    }
    this.setState({ checkedKeys: value });
    setStateCheckedKeys(value.checked);
    setStateSelectedItems(selectedItems);
  };

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={this.titleItem(item)} key={item.uuid} value={item.uuid} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          title={this.titleItem(item)}
          key={item.uuid}
          value={item.uuid}
          dataRef={item}
          {...item}
        />
      );
    });
  };

  titleItem = item => {
    return (
      <span className="treeTitle">
        <span style={{ width: '200px' }}>{item.name}</span>
      </span>
    );
  };

  render() {
    const { list, checkedKeys } = this.state;
    return (
      <div>
        <Tree checkable onCheck={this.onCheck} checkedKeys={checkedKeys} checkStrictly>
          {this.renderTreeNodes(list || [])}
        </Tree>
      </div>
    );
  }
}

export default SelectOrg;



// WEBPACK FOOTER //
// ./src/components/boss/user/SelectOrg.js